import React, { FunctionComponent } from 'react'
import Link from 'next/link'
import cn from 'classnames'

import { useMarketingUrl } from '@/hooks/MarketingUrl'

import styles from '@/modules/MainLayout/components/NavigationLinkWithSubMenu/NavigationLinkWithSubMenu.module.scss'

type NavigationLinkProps = {
  link: string
  className?: string
  title: string
  onClick?: () => void
}
export const NavigationLink: FunctionComponent<NavigationLinkProps> = ({
  link,
  className,
  title,
  onClick,
}) => {
  const marketingUrl = useMarketingUrl()
  const href = marketingUrl(
    link != null && link.length > 0 ? link : 'javascript:;'
  )

  return (
    <>
      <Link
        onClick={onClick}
        href={href}
        className={cn(className, styles.link)}
      >
        <span
          className={cn(styles.title, {
            [styles.titleLink]: link != null && link.length > 0,
          })}
        >
          {title}
        </span>
      </Link>{' '}
    </>
  )
}
